import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Trophy, ArrowLeft, Home } from "lucide-react";

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFBFC] flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <div className="relative mb-8">
          <div className="text-[140px] font-extrabold text-gray-100 leading-none select-none" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>404</div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
              <Trophy className="h-10 w-10 text-green-600" />
            </div>
          </div>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Page Not Found</h1>
        <p className="text-gray-500 mb-8 leading-relaxed">
          Looks like this page took a red card and got sent off! The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={() => navigate(-1)} variant="outline" className="rounded-full px-6" data-testid="go-back-btn">
            <ArrowLeft className="h-4 w-4 mr-2" /> Go Back
          </Button>
          <Button onClick={() => navigate("/")} className="bg-green-600 hover:bg-green-700 text-white rounded-full px-6" data-testid="go-home-btn">
            <Home className="h-4 w-4 mr-2" /> Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
